import React from 'react';
import PageRenderer from '../../components/common/PageRenderer';

function DefaultContent() {
  return (
    <>
      <section className="relative overflow-hidden bg-[#0B5D1E]" style={{ backgroundImage: 'linear-gradient(135deg, #0B5D1E 0%, #094A18 100%)' }}>
        <div className="relative" style={{ paddingTop: 80, paddingBottom: 80, zIndex: 1 }}>
          <div className="max-w-5xl mx-auto px-4 text-center">
            <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 700, color: '#fff', marginBottom: 16, fontFamily: "'Playfair Display',serif" }}>
              Publications
            </h1>
            <p className="text-white/70 text-lg max-w-2xl mx-auto">
              Research papers, journals, and resources from NIS FCT Branch
            </p>
          </div>
        </div>
      </section>

      {/* Publication Categories */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-3 text-center" style={{ fontFamily: "'Playfair Display',serif" }}>Our Publications</h2>
          <p className="text-gray-500 text-center max-w-2xl mx-auto mb-12">
            Access a wide range of professional resources, technical papers, and institutional publications from the NIS FCT Branch.
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: '📄', title: 'Technical Papers', desc: 'Research and technical papers on surveying methodologies, geospatial sciences, and land administration.' },
              { icon: '📰', title: 'Newsletters', desc: 'Periodic newsletters covering branch activities, member achievements, and industry updates.' },
              { icon: '📘', title: 'Annual Reports', desc: 'Comprehensive reports on the branch\'s activities, financials, and achievements for each year.' },
              { icon: '📋', title: 'Conference Proceedings', desc: 'Papers and presentations from conferences, workshops, and seminars organized by the branch.' },
              { icon: '📖', title: 'Guidelines & Standards', desc: 'Professional practice guidelines, industry standards, and best practice documents for surveyors.' },
              { icon: '🎓', title: 'Training Materials', desc: 'CPD materials, workshop handouts, and educational resources for professional development.' },
            ].map((item) => (
              <div key={item.title} className="bg-[#F8FAFB] rounded-xl p-6 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                <div className="text-3xl mb-4">{item.icon}</div>
                <h3 className="text-lg font-bold text-[#0B5D1E] mb-2">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-[#F8FAFB]">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <div className="bg-white rounded-2xl p-8 md:p-12 border border-gray-100 shadow-sm">
            <div className="w-16 h-16 rounded-full bg-[#C8A951]/10 flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-[#C8A951]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Playfair Display',serif" }}>Submit a Publication</h3>
            <p className="text-gray-500 mb-6 max-w-md mx-auto">
              Are you a member with a research paper, technical report, or article you'd like to share? Contact the branch publications committee to have your work featured.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default function Publications() {
  return <PageRenderer pageKey="publications" fallback={<DefaultContent />} />;
}
